function splitInternationalNumber
(
    digitsOnly: string
): { countryCode: string; localNumber: string }
{
    let countryCodeLength: number;
    let countryCode: string;
    let localNumber: string;

    countryCodeLength = 1;

    if (digitsOnly.length >= 13)
    {
        countryCodeLength = 3;
    }
    else if (digitsOnly.length === 12)
    {
        countryCodeLength = 2;
    }

    countryCode = digitsOnly.substring(0, countryCodeLength);
    localNumber = digitsOnly.substring(countryCodeLength);

    return { countryCode, localNumber };
}

function formatLocalNumber
(
    localNumber: string
): string
{
    let result: string;
    let areaCode: string;
    let firstThree: string;
    let lastFour: string;
    let groupedParts: string[];
    let index: number;
    let nextPart: string;

    if (!localNumber)
    {
        return '';
    }

    if (localNumber.length <= 3)
    {
        result = '(' + localNumber;
        return result;
    }

    areaCode = localNumber.substring(0, 3);
    firstThree = localNumber.substring(3, 6);
    lastFour = localNumber.substring(6, 10);

    if (localNumber.length <= 6)
    {
        result =
            '(' + areaCode + ')' +
            firstThree;
        return result;
    }

    if (localNumber.length <= 10)
    {
        result =
            '(' + areaCode + ')' +
            firstThree + '-' +
            lastFour;
        return result;
    }

    groupedParts = [];
    index = 0;

    while (index < localNumber.length)
    {
        nextPart = localNumber.substring(index, index + 3);
        groupedParts.push(nextPart);
        index = index + 3;
    }

    result = groupedParts.join('-');

    return result;
}

function formatPhoneNumber
(
    phoneValue: string
): string
{
    let normalizedValue: string;
    let digitsOnly: string;
    let isPlusPrefixed: boolean;
    let localNumber: string;
    let splitNumber: { countryCode: string; localNumber: string };
    let formattedLocal: string;
    let result: string;

    normalizedValue = String(phoneValue || '').trim();

    if (!normalizedValue)
    {
        return normalizedValue;
    }

    isPlusPrefixed = normalizedValue.startsWith('+');
    digitsOnly = normalizedValue.replace(/\D/g, '');

    if (!digitsOnly)
    {
        return normalizedValue;
    }

    if (digitsOnly.length === 10)
    {
        result = formatLocalNumber(digitsOnly);
        return result;
    }

    if (digitsOnly.length === 11 && digitsOnly.startsWith('1'))
    {
        localNumber = digitsOnly.substring(1);
        formattedLocal = formatLocalNumber(localNumber);
        result = isPlusPrefixed ? '+1 ' + formattedLocal : formattedLocal;
        return result;
    }

    if (digitsOnly.length > 10)
    {
        splitNumber = splitInternationalNumber(digitsOnly);
        formattedLocal = formatLocalNumber(splitNumber.localNumber);
        result = '+' + splitNumber.countryCode + ' ' + formattedLocal;
        return result;
    }

    result = formatLocalNumber(digitsOnly);

    return result;
}

export { formatPhoneNumber };
